import { Stack } from "@mui/material";
import { Icon, type IconName } from "components/Icon";
import { useTranslation } from "react-i18next";

import { FLUSHING_SETTINGS_CELL_CLASS_NAME, FLUSHING_SETTINGS_VALUES_CLASS_NAME } from "../lib/transientForm";

const ColumnHeader = ({ iconName, label }: { iconName: IconName; label: string }) => (
  <Stack className="flex-row items-center gap-1.5">
    <Icon color="var(--color-foreground-secondary)" iconName={iconName} size="sm" />
    <span className="text-lds-foreground-secondary font-ds-body-semibold-sm">{label}</span>
  </Stack>
);

export const ScenarioDayNightFlushingHeader = () => {
  const { t } = useTranslation();
  const label = (key: string) => t(`Execution.transient.scenario.dayNightFlushing.${key}`);

  return (
    <Stack className="w-full justify-between pb-1 border-b-ds-soft">
      <span className="font-ds-headline-sm text-lds-foreground-primary">{label("title")}</span>
      <div className={FLUSHING_SETTINGS_VALUES_CLASS_NAME}>
        <div className={FLUSHING_SETTINGS_CELL_CLASS_NAME}>
          <ColumnHeader iconName="Moon" label={label("night")} />
        </div>
        <div className={FLUSHING_SETTINGS_CELL_CLASS_NAME}>
          <ColumnHeader iconName="Sun" label={label("day")} />
        </div>
      </div>
    </Stack>
  );
};
